import { Service } from '@angular/core';

import { BarErrorHandlerHook, BarErrorHandlerHookArgs } from './bar-error-handler.hook';

@Service({ autoProvided: false })
export class BarErrorExpressionChangedAfterCheckedHook implements BarErrorHandlerHook {
    /** Invoked by the error handler. */
    run(args: BarErrorHandlerHookArgs): void {
        if (
            args.error &&
            // NOTE since ng 18 we get -100 code
            (args.error.code === '100' || args.error.code === -100) &&
            args.error.message &&
            (args.error.message as string).indexOf('NG0100') > -1
        ) {
            args.handled = true;
            console.error(args.error);
        }
    }
}
